<template>
  <div class="el-upload">
    <el-form>
      <el-upload :limit="limitNumber" action="" accept="image/*" :http-request="uploadFile" list-type="picture-card"
        :auto-upload="true" :show-file-list="false" :on-preview="handlePictureCardPreview" :on-exceed="handleExceed"
        :before-remove="beforeRemove" ref="upload">
        <!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
        <div class="addbox" v-if="!imageUrl">
          <i class="el-icon-plus addicon"></i>
          <!-- <img src="../assets/icon_add_24hui@2x.png" alt="" class="addicon" /> -->
        </div>
        <img v-else :src="imageUrl" width="88" height="88" />
      </el-upload>
      <!--
        <el-form-item>
          <el-button size="small" type="primary" style="margin-top: 20px;" @click="submitUpload">点击上传</el-button>
        </el-form-item>
        -->
      <el-dialog :visible.sync="dialogVisible" append-to-body>
        <img width="100%" fit="contain" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </el-form>
  </div>
</template>
<script>
// import { uploadImg, delUpIamge } from '@/api/publicSeries'
export default {
  props: {
    limitNumber: {
      type: Number,
      default: 100
    },
    fileList: {
      type: Array,
      default: () => []
    },
    showAddIcon: {
      type: Boolean,
      default: true
    },
    qrCodeUrl: {
      type: String,
      default: ''
    }
  },
  watch: {
    qrCodeUrl(val, vall) {
      this.imageUrl = val
    }
  },
  data() {
    return {
      imageUrl: '',
      dialogImageUrl: '',
      dialogVisible: false
    }
  },
  methods: {
    submitUpload() { this.$refs.upload.submit() },
    uploadFile(e) {
      const file = e.file
      const size = file.size / 1024 / 1024 / 2
      console.log(size)
      if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        this.$notify.warning({
          title: '警告',
          message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
        })
        return
      } else if (size > 2) {
        this.$notify.warning({
          title: '警告',
          message: '图片大小必须小于2M'
        })
        return
      } else {
        const params = new FormData()
        params.append('file', file) // 图片
        console.log(params)
        this.$api.uploadFiles(params).then(res => {
          if (res.code === 0) {
            this.$message.success('上传成功')
            this.imageUrl = this.ImgHttps + res.data.url
            this.$emit('getUrl', this.imageUrl)
          } else {
            this.$message.error('上传失败')
          }
        })
      }
    },
    // 图片上传超过数量限制
    handleExceed(files, fileList) {
      this.$message.error('图片数量超出限制!')
      console.log(files, fileList)
    },
    // 删除图片
    beforeRemove(file, fileList) {
      const url = file.url
      this.$emit('handleRemove', url)
    },
    // 预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.el-dialog .el-dialog__header {
  border-bottom: none;
}

::v-deep .el-upload--picture-card {
  width: 90px;
  height: 90px;
  background: #ffffff;
  border: 1px solid #E3E6E5;
  border-radius: 3px;
  line-height: normal;
}

.addbox {
  width: 100%;
  height: 100%;
  background: transparent;
  // border: 1px solid #C0C0CC;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  /* margin-left: 20px; */
}

.addicon {
  width: 24px;
  height: 24px;
  font-size: 20px;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #c3c3cf;
}
</style>
  